<template class="bg-gradient-primary">
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Bienvenido!</h1>
                  </div>
                  <form action class="user" @submit.prevent="login">
                    <div class="form-group">
                      <input  v-model="email" type="email" class="form-control form-control-user" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Correo eléctronico">
                    </div>
                    <div class="form-group">
                      <input v-model="password" type="password" class="form-control form-control-user" id="exampleInputPassword" placeholder="Contraseña">
                    </div>
                    <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input type="checkbox" class="custom-control-input" id="customCheck">
                        <label class="custom-control-label" for="customCheck">Recuérdame</label>
                      </div>
                    </div>
                    <input class="btn btn-primary btn-user btn-block" type="submit" value="Login">
                    <hr>
                  </form>
                  <hr>
                  <div class="text-center">
                    <a class="small" href="forgot-password.html">Olvidé mi contraseña</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>

// import auth from "@/store/auth.js";
export default {
  created () {
    this.$store.commit('SET_LAYOUT', 'login-layout')
  },
  data: () => ({
    email: "",
    password: ""
  }),
  head () {
    return {
      title: 'Ingreso',
    }
  },
  methods: {
    // async login() {
    //   try {
    //     await auth.login(this.email, this.password);
    //     const user = {
    //       email: this.email
    //     };
    //     auth.setUserLogged(user);
    //     this.$router.push("/");
    //   } catch (error) {
    //     console.log(error);
    //     this.error = true;
    //   }
    // }
    login() {
      console.log(this.email);
      console.log(this.password);
      console.log(this.$route);
      // if(this.email === 'test@mail.com' &&
      //   this.password === '123' ){
      //     this.$router.push('/about');
      // }
      this.$router.push("/");
    }
  }
};
</script>

<style>

</style>
